import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  EFieldType,
  EPageLayout,
  IInputGroupOptions,
  InputGroupComponent,
  ITab,
  PageLayoutComponent,
  TabNavigationComponent,
  TabNavigationStateService,
  tabNavigationStateServiceInjectionToken
} from "@zaeper/angular-dashboard-view-lib";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ZTemplateDirective } from "@zaeper/angular-core-lib";

@Component( {
  selector: 'app-version-detail-page',
  templateUrl: 'app-version-detail-page.component.html',
  imports: [
    PageLayoutComponent, InputGroupComponent, ZTemplateDirective, TabNavigationComponent
  ],
  providers: [
    {
      provide: tabNavigationStateServiceInjectionToken,
      useClass: TabNavigationStateService
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
} )
export class AppVersionDetailPageComponent {
  protected readonly EPageLayout = EPageLayout;
  protected readonly appVersionForm: FormGroup;
  protected readonly localizedInfoInputGroup: IInputGroupOptions;
  protected readonly tabs: ITab[] = [
    {
      title: "Details",
      subject: "details"
    }, {
      title: "Einstellungen",
      subject: "settings"
    }
  ];

  constructor(private readonly _formBuilder: FormBuilder) {
    this.appVersionForm = this._formBuilder.group( {
      description: new FormControl( "" )
    } );

    this.localizedInfoInputGroup = this._createLocalizedInfoInputGroup();
  }

  private _createLocalizedInfoInputGroup(): IInputGroupOptions {
    return {
      groupId: "version-details",
      title: "Versionsdetails",
      children: [
        {
          fieldType: EFieldType.TEXTAREA,
          title: 'Änderungsbeschreibung (Changelog)',
          inputId: 'description',
          placeholder: 'Änderungsbeschreibung (Changelog)',
          description: "Was hat sich seit der letzten Version verändert?",
          required: false,
          formControlEntry: {
            formControl: this.appVersionForm.get( "description" ) as FormControl<string | null>,
            key: "description"
          },
          wysiwygEditor: false
        }
      ]
    };
  }
}
